import getRestrictedOptions from "./get-restricted-options";

/**
 *
 * @param {OptionsListMapProps} global
 * @param {OptionsListMapProps} common
 * @param {OptionsListMapProps} defaults
 * @param {String} type
 * @returns
 */
const getMergeable = (global, common, defaults, type) => {
  /** Inheriting parent */
  switch (true) {
    /** Inherit options from timeline */
    case type === "timeline":
      return getRestrictedOptions(global, common, defaults);

    /** Inherit options from cluster */
    case type === "cluster":
      return global;

    /** Get default options */
    default:
      return defaults;
  }
};

export default getMergeable;
